import React from 'react';
import { createPortal } from 'react-dom';
import { Portal } from '@material-ui/core';

const bottomRoot = document.getElementById('root-bottom');
const headerRoot = document.getElementById('root-header');

export const PortalRootBottom = ({ children }) => createPortal(children, bottomRoot);

export const PortalRootHeader = ({ children }) => createPortal(children, headerRoot);

export const PortalBody = ({ children }) => <Portal container={document.body}>{children}</Portal>;

export const PortalRootMain = ({ children }) => {
  const mainRoot = document.getElementById('root-main');
  return createPortal(children, mainRoot);
};

export const PortalNavbarAttachment = ({ children }) => {
  const navbarAttachment = document.getElementById('Navbar__attachment');
  return createPortal(children, navbarAttachment);
};

export const PortalNavbarRightside = ({ children }) => {
  const navbarRightside = document.getElementById('Navbar__rightside') || headerRoot;
  return createPortal(children, navbarRightside);
};

export const PortalFilterbarArea = ({ children }) => {
  const filterbarArea = document.getElementById('filterbar-area');
  return createPortal(children, filterbarArea);
};
